import type { ChartConfig } from "@/components/ui/chart";
import { Drawer, DrawerContent } from "@/components/ui/drawer";
import { ChoiceBar } from "./ChoiceBar";

export interface Choice {
  id: string;
  name: string;
  latestProbability?: number;
}

interface Props {
  isFilterSelectOpen: boolean;
  onClose: () => void;
  chartConfig: ChartConfig;
  allChoices: Choice[];
  selectedChoiceIds: string[];
  setSelectedChoiceIds: (ids: string[]) => void;
}

export const FilterSelect = ({
  isFilterSelectOpen,
  onClose,
  chartConfig,
  allChoices,
  selectedChoiceIds,
  setSelectedChoiceIds,
}: Props) => {
  const maxSelections = 4;

  const handleToggleChoice = (choiceId: string, checked: boolean) => {
    if (checked) {
      // Add choice if under the limit
      if (selectedChoiceIds.length < maxSelections) {
        setSelectedChoiceIds([...selectedChoiceIds, choiceId]);
      }
    } else {
      // Remove choice
      setSelectedChoiceIds(selectedChoiceIds.filter((id) => id !== choiceId));
    }
  };

  return (
    <Drawer open={isFilterSelectOpen} onOpenChange={(open) => !open && onClose()}>
      <DrawerContent>
        <div className="px-[20px] pb-8">
          <div className="mb-4">
            <div className="font-bold">グラフに表示したい項目を選択してください</div>
            <div>※4項目まで</div>
          </div>
          <div className="grid gap-4">
            {allChoices.map((choice) => {
              const isSelected = selectedChoiceIds.includes(choice.id);
              const isDisabled = !isSelected && selectedChoiceIds.length >= maxSelections;
              const choiceColor = chartConfig[choice.id]?.color || "#000000";

              return (
                <ChoiceBar
                  checked={isSelected}
                  key={choice.id}
                  choice={choice}
                  disabled={isDisabled}
                  color={choiceColor}
                  onCheckedChange={() => handleToggleChoice(choice.id, !isSelected)}
                />
              );
            })}
          </div>
        </div>
      </DrawerContent>
    </Drawer>
  );
};
